export default "__VITE_ASSET__BlTaWr5m__"